import { render, staticRenderFns } from "./LessonMediaDeleteConfirmationDialog.vue?vue&type=template&id=4862c840"
import script from "./LessonMediaDeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./LessonMediaDeleteConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports